import { z } from 'zod'

export const editChartLabelSchema = z.object({
  title: z.string(),
  hexColor: z.string().regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/),
  description: z.string().optional(),
})

export type TEditChartLabelFields = z.infer<typeof editChartLabelSchema>
